import { AddObjectKeyRequest, UpdateObjectKeyRequest, UpdateObjectValueRequest, UpdateObjectInstanceRequest, ObjectKeyResponse, ObjectKeyUpdateResponse, ObjectValueResponse, DeleteObjectKeyResponse } from "@/backend/express/controllers/fieldObjectController";
import { Client } from "./client";


export class FieldObjectController {
  private client: Client;

  constructor() {
    this.client = new Client();
  }

  public async addObjectKey(data: AddObjectKeyRequest): Promise<ObjectKeyResponse> {
    return this.client.create('/api/field-objects/addObjectKey', data);
  }

  public async updateObjectKey(data: UpdateObjectKeyRequest): Promise<ObjectKeyUpdateResponse> {
    return this.client.update('/api/field-objects/updateObjectKey', data);
  }

  public async updateObjectValue(data: UpdateObjectValueRequest): Promise<ObjectValueResponse> {
    return this.client.update('/api/field-objects/updateObjectValue', data);
  }

  public async deleteObjectKey(id: string): Promise<DeleteObjectKeyResponse> {
    return this.client.delete(`/api/field-objects/deleteObjectKey/${id}`);
  }

  public async updateObjectInstance(data: UpdateObjectInstanceRequest) {
    return this.client.update('/api/field-objects/updateObjectInstance', data);
  }
}
